export const getMatchupSlug = game => {
  const { teams = {} } = game;
  const { home = {}, away = {} } = teams;
  const { team: homeTeam = {} } = home;
  const { team: awayTeam = {} } = away;

  return `${awayTeam.abbreviation} @ ${homeTeam.abbreviation}`;
};



// WEBPACK FOOTER //
// ./src/utils/game.js